/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const EvalTaskType = {
  Classification: "classification",
  MultipleChoice: "multiple_choice",
  Qa: "qa",
  Summarization: "summarization",
  SemanticSimilarity: "semantic_similarity",
  LlmJudge: "llm_judge",
  Numeric: "numeric",
  Math: "math",
  Custom: "custom",
  Transcription: "transcription",
} as const;
export type EvalTaskType = ClosedEnum<typeof EvalTaskType>;

/** @internal */
export const EvalTaskType$inboundSchema: z.ZodNativeEnum<typeof EvalTaskType> =
  z.nativeEnum(EvalTaskType);
/** @internal */
export const EvalTaskType$outboundSchema: z.ZodNativeEnum<typeof EvalTaskType> =
  EvalTaskType$inboundSchema;
